import ServiceExec from '@/common/utils/ServiceExec';
import classApi from '@/common/service/apis/ClassApi';

class ClassSvc extends ServiceExec {
  getStudyList(params = {}) {
    return this.get(classApi.getStudyList, params)
      .then(response => {
        return {
          data: response.data
        };
      })
      .catch(error => {
        console.log('getStudyList error: ', error);
      });
  }

  getStudentOrderList(params = {}) {
    return this.get(classApi.getStudentOrderList, params)
      .then(response => {
        return {
          data: response.data
        };
      })
      .catch(error => {
        console.log('getStudentOrderList error: ', error);
      });
  }

  getOrderDetail(params) {
    return this.patch(classApi.getOrderDetail(params.studentOrderNo, params.orderIndex))
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getOrderDetail error: ', error);
      });
  }
}

export default new ClassSvc();
